var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.6665L13.0869 10.3499C12.9813 12.0574 12.9285 12.9112 12.5005 13.5251C12.2889 13.8286 12.0165 14.0847 11.7005 14.2772C11.0614 14.6665 10.206 14.6665 8.49513 14.6665C6.78208 14.6665 5.92553 14.6665 5.28603 14.2764C4.96987 14.0836 4.69733 13.827 4.48579 13.523C4.05792 12.9082 4.0063 12.0532 3.90307 10.3433L3.5 3.6665",
    stroke: "#FF2B1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.66683H14.5M11.2038 3.66683L10.7487 2.72798C10.4464 2.10434 10.2952 1.79251 10.0345 1.59804C9.97667 1.5549 9.9154 1.51652 9.85133 1.4833C9.5626 1.3335 9.21607 1.3335 8.523 1.3335C7.81253 1.3335 7.45733 1.3335 7.16379 1.48958C7.09873 1.52417 7.03665 1.5641 6.97819 1.60894C6.71443 1.8113 6.56709 2.13453 6.27241 2.781L5.86861 3.66683",
    stroke: "#FF2B1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83325 11V7",
    stroke: "#FF2B1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 11V7",
    stroke: "#FF2B1E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9e1c8553805e834b85afe78d1636fe6d.svg";
export { ForwardRef as ReactComponent };